import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { CompanyActions, CycleCountActions } from "redux/actions";

interface ICycleCountState extends IBaseReducerState {}

const initialState: ICycleCountState = {
  action: CycleCountActions.prefix,
  prefix: CycleCountActions.prefix,
};

const UserReducer = ReduxHelper.createHandleReducer<ICycleCountState>(
  initialState,
  (builder) => {}
);

export default UserReducer;
